import { Member } from '../member/member.model';
import { ServiceBooking } from './service-booking.model';

export class StandaloneServiceBooking extends ServiceBooking {
  owner: Member | string;

  constructor(values= {}) {
    super(values);
    Object.assign(this, values);
  }
}
